module.exports = __webpack_public_path__ + "img/Building the plane while flying it.0539f67e.png";